"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocationNameForId = exports.parseMinutesToFormat = exports.getEmployeeNameShort = exports.parseMinutesToHumanForm = exports.convertMinutesTo24HourFormat = exports.parseMinutesToDecimalForm = exports.parseMinutesToTeachingHoursForm = void 0;
var moment_1 = __importDefault(require("moment"));
var parseMinutesToTeachingHoursForm = function (minutes) { return (minutes / 45).toFixed(2); };
exports.parseMinutesToTeachingHoursForm = parseMinutesToTeachingHoursForm;
var parseMinutesToDecimalForm = function (minutes) { return (minutes / 60).toFixed(2); };
exports.parseMinutesToDecimalForm = parseMinutesToDecimalForm;
var convertMinutesTo24HourFormat = function (minutes) {
    return moment_1.default.utc().startOf('day').add(minutes, 'minutes').format('HH:mm');
};
exports.convertMinutesTo24HourFormat = convertMinutesTo24HourFormat;
var parseMinutesToHumanForm = function (minutes, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.dontDisplayZeroHours, dontDisplayZeroHours = _c === void 0 ? false : _c;
    if (minutes >= 0) {
        if (minutes < 60 && dontDisplayZeroHours)
            return "".concat(minutes, "m");
        return "".concat(Math.floor(minutes / 60), "h ").concat(minutes % 60, "m");
    }
    var absMinutes = Math.abs(minutes);
    if (absMinutes < 60 && dontDisplayZeroHours)
        return "-".concat(absMinutes, "m");
    return "-".concat(Math.floor(absMinutes / 60), "h ").concat(absMinutes % 60, "m");
};
exports.parseMinutesToHumanForm = parseMinutesToHumanForm;
var getEmployeeNameShort = function (employee, length) {
    var firstName = employee.first_name;
    var lastName = employee.last_name;
    if (!firstName || !lastName)
        return '';
    var result = "".concat(firstName, " ").concat(lastName);
    if (result.length > length) {
        if (lastName === ' ') {
            result = "".concat(result.slice(0, length - 3), "...");
        }
        else {
            result = "".concat(firstName.slice(0, 1), ". ").concat(lastName);
        }
    }
    if (result.length > length) {
        result = "".concat(result.slice(0, length - 3), "...");
    }
    return result;
};
exports.getEmployeeNameShort = getEmployeeNameShort;
var parseMinutesToFormat = function (minutes, format, returnFloatForDecimalFormat) {
    if (format === void 0) { format = 'hours'; }
    if (returnFloatForDecimalFormat === void 0) { returnFloatForDecimalFormat = false; }
    if (Number.isNaN(Number(minutes)) || Number(minutes) === 0)
        return '0';
    switch (format) {
        case 'decimal':
            if (returnFloatForDecimalFormat)
                return parseFloat((0, exports.parseMinutesToDecimalForm)(minutes));
            return (0, exports.parseMinutesToDecimalForm)(minutes);
        case 'teachingHours':
            if (returnFloatForDecimalFormat)
                return parseFloat((0, exports.parseMinutesToTeachingHoursForm)(minutes));
            return (0, exports.parseMinutesToTeachingHoursForm)(minutes);
        case '24Hour':
            if (returnFloatForDecimalFormat)
                return (0, exports.convertMinutesTo24HourFormat)(minutes);
            return (0, exports.convertMinutesTo24HourFormat)(minutes);
        default:
            return (0, exports.parseMinutesToHumanForm)(minutes);
    }
};
exports.parseMinutesToFormat = parseMinutesToFormat;
var getLocationNameForId = function (id, userLocations, notFoundLocationText) {
    if (notFoundLocationText === void 0) { notFoundLocationText = ''; }
    if (userLocations && userLocations.length) {
        var foundLocation = userLocations.find(function (l) { return String(l.id) === String(id); });
        if (foundLocation) {
            return foundLocation.name;
        }
    }
    else {
        console.warn('userLocations is empty');
    }
    return notFoundLocationText === null ? 'Brak lokalizacji' : notFoundLocationText;
};
exports.getLocationNameForId = getLocationNameForId;
